import { BlockForm } from "@/components/blocks/block-form";

export default function NewBlockPage() {
  return (
    <div className="container mx-auto px-4 py-8 pb-24 sm:pb-8 max-w-lg">
      <BlockForm mode="create" />
    </div>
  );
}
